<script setup lang="ts">

</script>

<template>
	<div class="layout layout--entry">
		<div class="main-container">
			<div class="main-wrapper">
				<main class="main">
					<div class="entry-wrapper">
						<slot />

						<HmBackdrop app="auth" v-if="$screen.md" />
						<HmCopyright app="auth" has-help is-absolute v-else />
					</div>
				</main>
			</div>
		</div>
	</div>
</template>
